module.exports = __webpack_public_path__ + "static/media/paint-roller.a7c9abbf.svg";